import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CustomFieldDetail, Order } from '@pedix-workspace/utils';

import { TranslocoDirective } from '@ngneat/transloco';
import { getSanitizedCustomFieldDetails } from '@pedix-workspace/orders';

export type OrderListDetailRenderEvent = {
  row: Order;
  height: number;
};

@Component({
  selector: 'pxw-order-details-custom-fields',
  templateUrl: './order-details-custom-fields.component.html',
  styleUrls: ['./order-details-custom-fields.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoDirective],
})
export class OrderDetailsCustomFieldsComponent {
  readonly customFieldDetails = input.required<CustomFieldDetail[]>();

  readonly sanitizedCustomFieldDetails = computed(() =>
    getSanitizedCustomFieldDetails(this.customFieldDetails()),
  );
}
